export const SVG_COLOR = "rgb(138, 40, 217)"
